import { useEffect, useState } from "react";
import styles from "./Header.module.css";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import CompanyName from "../CompanyName/CompanyName";
import BookStay from "../BookYourStay/BookYourStay";
import { useLocation } from "react-router-dom";

const Header = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setVisible(currentScrollY > (40 * window.innerHeight) / 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      location.pathname === "/" &&
        window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (location.pathname !== "/") setVisible(true);
  }, [location, visible]);

  return (
    <header className={`${styles.headerMain} ${visible ? styles.visible : ""}`}>
      <div className={styles.dropdownMenuContainer}>
        <DropdownMenu isVisible={visible} />
      </div>
      <div className={styles.companyNameContainer}>
        <CompanyName isVisible={visible} />
      </div>
      <div className={styles.bookStayContainer}>
        <BookStay isVisible={visible} />
      </div>
    </header>
  );
};

export default Header;
